
import { Component, Mixins } from "vue-property-decorator";
import { ITextSearchBehavior } from "../../../../../../documaker/domain/format/objects";
import { ITextSearchBehaviorPropertyEditable, instanceOfITextSearchBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class TextSearchBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ITextSearchBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ITextSearchBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isTextSearchBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfITextSearchBehaviorPropertyEditable(s) && s.textSearchBehavior().isEditable(), false);
  }

  get textSearchBehavior(): ITextSearchBehavior {
    return this.readPropertyOrDefault(s => s.textSearchBehavior().getValue(), { isEnable: false });
  }

  set textSearchBehavior(value: ITextSearchBehavior) {
    this.writePropertyWhenValid(s => s.textSearchBehavior().setValue(value));
  }
}
